<template>
  <div class="supplier_login"
       :style="note">
    <!-- <van-nav-bar title="商城"
                 class="title">
      <van-icon name="cross"
                slot="left" />>
      <van-icon name="ellipsis"
                slot="right" />
    </van-nav-bar> -->
    <van-form @submit="onSubmit">
      <div class="form">
        <van-image round
                   cover
                   class="image"/>

        <van-field name="用户名"
                   v-model="username"
                   placeholder="请输入登录账号"
                   :rules="[{ required: true, message: '请填写用户名' }]"
                   :left-icon="phone" />
        <van-field type="password"
                   v-model="password"
                   name="密码"
                   placeholder="请输入密码"
                   :left-icon="key"
                   :rules="[{ required: true, message: '请填写密码' }]" />
        <div class="checked">
          <van-checkbox v-model="checked"
                        shape="square"
                        icon-size="13px"><a href="javascript:;" @click.stop="toPageAgent">我已阅读《供应商服务协议》</a></van-checkbox>
        </div>
      </div>
      <div class="tips">更改密码请登录电脑端修改或者联系客服 http://ckaicai.com/admin/login</div>
      <div class="btn_login" @click="login">
        <div class="btn">
          <span class="text">登录</span>
          <img class="img"
               :src="right">
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { login, logout, getUserInfo } from '@/api/login'
export default {
  name: 'supplierLogin',
  data () {
    return {
      phone: require('@/assets/phone1.png'),
      key: require('@/assets/key.png'),
      right: require('@/assets/right1.png'),
      checked: true,
      username: '',
      password: '',
      note: {
        backgroundImage: "url(" + require("@/assets/bgc.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      },
    }
  },
  created(){
    let openid = this.getUrlKey('openid')
    if (openid != null) {
      localStorage.setItem('openid',openid)
    }
  },
  methods: {
    getUrlKey(name){
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(decodeURI(window.location.href)) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    toPageAgent() {
      this.$router.push('/business/agreement')
    },
    onSubmit () {
      console.log('123');
    },
    login () {
      if (!this.username){
        this.$toast.fail("请输入账号");
        return;
      }
      if (!this.password){
        this.$toast.fail("请输入密码");
        return;
      }
      let form = {
        username: this.username,
        password: this.password,
        openId: localStorage.getItem("openid")
      }
      login(form).then(response => {
        localStorage.setItem('storeInfo',JSON.stringify(response.data.userInfo))
        if (response.data.userInfo.storeId != null) {
          localStorage.setItem('storeId',response.data.userInfo.storeId)
        }
        this.$router.push({
          path:'/business'
        })
      }).catch(error => {
        // 登录失败，回传提示信息

      })
    }
  }
}
</script>

<style lang="less" scoped>
.supplier_login {
  height: 100vh;
  overflow: hidden;
  .title {
    background-color: #ededed;
    .van-icon {
      font-size: 20px;
      color: #333;
    }
  }
  .form {
    position: relative;
    box-sizing: border-box;
    width: 314px;
    height: 260px;
    margin: 105px auto 0;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    padding: 70px 15px 0;
    .van-field {
      margin-bottom: 10px;
      font-size: 16px;
      color: #999;
    }
  }
  .image {
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 80px;
    z-index: 999;
  }
  .checked {
    margin-left: 10px;
    margin-top: 20px;
    a {
      font-size: 14px;
      color: #7b7f99;
    }
  }
  .tips{
    text-align: center;
    font-size: 14px;
    color: red;
    margin-top: 10px;
  }
  .btn_login {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .btn {
      position: relative;
      width: 150px;
      height: 42px;
      background-color: #fe003b;
      border-radius: 21px;

      font-size: 20px;
      color: #fff;
      .text {
        position: absolute;
        top: 6px;
        left: 33px;
        font-size: 20px;
      }
      .img {
        position: absolute;
        right: 33px;
        top: 11px;
        width: 20px;
        height: 20px;
      }
    }
  }
  /deep/.van-field__left-icon {
    margin-right: 10px;
  }
  .ball1 {
    position: absolute;
    top: 470px;
    left: 320px;
    width: 19px;
    height: 19px;
    background: -webkit-linear-gradient(top, #eafabe 0%, #7ee1d1 100%);
    border-radius: 9px;
  }
  .ball2 {
    position: absolute;
    top: 540px;
    left: 227px;
    width: 31px;
    height: 31px;
    background: -webkit-linear-gradient(top, #f83c01 0%, #f88712 100%);
    border-radius: 15px;
    opacity: 0.6;
  }
  .ball3 {
    position: absolute;
    left: 105px;
    top: 540px;
    width: 65px;
    height: 65px;
    background: -webkit-linear-gradient(top, #fe003b 0%, #dc1bfb 100%);
    border-radius: 32px;
    opacity: 0.6;
    z-index: 999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/business/login/supplierLogin.vue